import { useMemo } from 'react';
export const useCustomerInfo = () => {
    const customerInfo = useMemo(() => {
        var _a, _b, _c, _d, _e, _f;
        if (typeof window === 'undefined') {
            return {
                role: '',
                customerType: '',
                svocID: '',
                userID: '',
                email: '',
            };
        }
        return {
            role: ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default.role) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || '',
            customerType: ((_c = window.THDCustomer) === null || _c === void 0 ? void 0 : _c.default.customerType) || '',
            svocID: ((_d = window.THDCustomer) === null || _d === void 0 ? void 0 : _d.default.svocID) || '',
            userID: ((_e = window.THDCustomer) === null || _e === void 0 ? void 0 : _e.default.userID) || '',
            email: ((_f = window.THDCustomer) === null || _f === void 0 ? void 0 : _f.default.email) || '',
        };
    }, []);
    return customerInfo;
};
